import { chain, size, indexOf, get } from 'lodash';

import {
  ITransferGrandTotal,
  ITransferDestination,
} from '@app/shared/types/entities/transfer/transfer.type';
import { decimalNumber } from '@app/shared/common/decimal-number/decimal-number';

import {
  DEPARTMENT_I18N_CODE_MAP,
  DEPARTMENT_SORT_LIST,
} from '../../transfer/transfer.definition';
import { XVII18nService } from '@app/i18n/services';

const calcDepartmentCosts = (
  items: ITransferDestination[],
  i18nService: XVII18nService,
): ITransferGrandTotal[] =>
  chain(items)
    .reduce(
      (
        allCostFields,
        curItem: ITransferDestination,
      ): Record<string, ITransferGrandTotal> => {
        const departmentCode = curItem.site_department_code_to;

        if (size(departmentCode) > 0) {
          const oldDepartmentCost = allCostFields[departmentCode];

          allCostFields[departmentCode] = {
            department_code: departmentCode,
            request_cost: decimalNumber(
              oldDepartmentCost?.request_cost || 0,
            ).add(curItem?.request_cost || 0),
            received_cost: decimalNumber(
              oldDepartmentCost?.received_cost || 0,
            ).add(curItem?.received_cost || 0),
            reversed_cost: decimalNumber(
              oldDepartmentCost?.reversed_cost || 0,
            ).add(curItem?.reversed_cost || 0),
          };
        }

        return allCostFields;
      },
      <Record<string, ITransferGrandTotal>>{},
    )
    .values()
    .map((item) => {
      const { request_cost, received_cost, reversed_cost } = item;

      return {
        ...item,
        request_cost: request_cost.valueOf(),
        received_cost: received_cost.valueOf(),
        reversed_cost: reversed_cost.valueOf(),
      };
    })
    .sortBy((item) => indexOf(DEPARTMENT_SORT_LIST, item.department_code))
    .map((item) => ({
      ...item,
      department_code: i18nService.instant(
        get(
          DEPARTMENT_I18N_CODE_MAP,
          item.department_code,
          item.department_code,
        ),
      ),
    }))
    .value();

export { calcDepartmentCosts };
